import { Icon, SvgIcon, Tooltip, useTheme } from '@salecycle/ui-component-library';
import { iconsSvgPath } from '@salecycle/ui-component-library/SvgIcons/svgIconsParams';
import React from 'react';
import styled from 'styled-components';
import { TooltipHtml } from '../common/TooltipHtml';

export enum IconProviderValue {
  FontAwesome,
  UiComponentLibrary,
}

interface IProps {
  active: boolean;
  icon: string;
  iconProvider: IconProviderValue;
  onClick?: (e?: React.MouseEvent) => void;
  tooltipHeading?: string;
  tooltipDescription?: string;
}

const TabElement = styled.div<IProps>`
  &&:hover {
    background-color: ${({ theme, active }) => (active ? theme.vars.newColor.blue1 : theme.vars.newColor.lightGS2)};
    border: ${({ theme, active }) =>
      active ? `1px solid ${theme.vars.newColor.blue1}` : `1px solid ${theme.vars.newColor.lightGS1}`};
  }
  &&:active {
    color: ${({ theme }) => theme.vars.newColor.white};
    background-color: ${({ theme }) => theme.vars.newColor.blue1};
    border: ${({ theme }) => `1px solid ${theme.vars.newColor.blue1}`};
    transition: none;
  }
  box-shadow: none;
  font-size: 14px;
  font-weight: normal;
  text-align: center;
  display: flex;
  justify-content: center;
  cursor: pointer;
  height: 30px;
  min-width: 30px;
  background-color: ${props => (props.active ? props.theme.vars.newColor.blue1 : 'transparent')};
  border: 1px solid transparent;
  padding: ${props => (props.iconProvider === IconProviderValue.UiComponentLibrary ? '5px' : '7px')};
  color: ${props => (props.active ? props.theme.vars.newColor.white : props.theme.vars.newColor.darkGS2)};

  svg {
    align-self: center;
    justify-self: center;
  }
`;

const getIcon = (props: IProps, theme: any) => {
  let icon = <Icon icon={props.icon} />;
  if (props.iconProvider === IconProviderValue.UiComponentLibrary) {
    icon = (
      <SvgIcon
        name={props.icon as keyof typeof iconsSvgPath}
        color={props.active ? theme.vars.newColor.white : theme.vars.newColor.darkGS2}
        size="24"
      />
    );
  }
  return icon;
};

export const SideBarTabIcon = (props: IProps) => {
  const theme = useTheme();
  const icon = getIcon(props, theme);
  return props.tooltipHeading ? (
    <Tooltip
      title={props.tooltipHeading}
      html={<TooltipHtml heading={props.tooltipHeading} description={props.tooltipDescription} />}
      position="right"
    >
      <TabElement {...props} className="tabButton" onClick={props.onClick} id={props.tooltipHeading}>
        {icon}
      </TabElement>
    </Tooltip>
  ) : (
    <TabElement {...props} className="tabButton" onClick={props.onClick} id={props.icon}>
      {icon}
    </TabElement>
  );
};

SideBarTabIcon.defaultProps = {
  iconProvider: IconProviderValue.FontAwesome,
};
